module.exports = __webpack_public_path__ + "static/media/profile-image.f6974fbd.svg";